//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { RoutingActions, RoutingActionType } from './routingActions';
import { IStateWithParams } from './routingModels';

export interface IRoutingState {
  currentTransition?: {
    to: IStateWithParams;
    from: IStateWithParams;
  };
  transitionedFrom?: IStateWithParams;
  redirectedFrom?: IStateWithParams;
}

export default function RoutingReducer(
    state: IRoutingState = {},
    action: RoutingActions,
    ): IRoutingState {
  switch (action.type) {
    case RoutingActionType.StateTransitionStart:
      {
                // Transition start events also fire when a transition "restarts"
        const isTransitionInProgress = !!state.currentTransition;
        return {
          ...state,
          currentTransition: {
            to: action.toState,
            from: action.fromState,
          },
          redirectedFrom: isTransitionInProgress ? state.redirectedFrom : undefined,
        };
      }
    case RoutingActionType.StateTransitionSuccess:
      return {
        ...state,
        currentTransition: undefined,
        transitionedFrom: action.fromState,
      };
    case RoutingActionType.StateTransitionRedirected:
      return {
        ...state,
        redirectedFrom: state.currentTransition?.to,
      };
    case RoutingActionType.StateTransitionError:
      return {
        ...state,
        currentTransition: undefined,
      };
  }
  return state;
}
